import { Level2OuterPageLoading } from "@octopusdeploy/design-system-components";
import { links } from "@octopusdeploy/portal-routes";
import { repository } from "~/clientInstance";
import { AsyncInternalRedirect } from "../AsyncInternalRedirect";
export function DefaultPlatformHubPageRedirect() {
    return (<AsyncInternalRedirect loader={async () => {
            const licenseCheck = await repository.Licenses.getFeatures();
            // TODO once we have implemented the other license feature checks, we can update to check each one individually.
            // For now, we just check if ProcessTemplates is enabled as it means the others are available, as they get generated together.
            if (!licenseCheck.EnabledFeatures.includes("ProcessTemplates")) {
                return links.platformHubUpsellPage.generateUrl();
            }
            // Always redirect to process templates page first (Process templates feature is now always enabled)
            return links.processTemplatesPage.generateUrl();
        }} renderWhenLoading={<Level2OuterPageLoading />}/>);
}
